// src/js/modules/wishlist.js
// Scoped bindings for wishlist toggle/menu (one-widget commit)

import { findAll, createObserverForSelector } from '../helpers/dom.js';

function initWishlist() {
  if (window.__planc_wishlist_initialized) return; window.__planc_wishlist_initialized = true;

  const toggleSel = '.wishlist-toggle, [data-wishlist-toggle], .yith-wcwl-add-button';
  const menuSel = '.wishlist-menu, [data-wishlist-menu], .yith-wcwl-wishlist';

  function attach(toggle, menu) {
    if (!toggle || !menu) return; if (toggle.__planc_wishlist_bound) return; toggle.__planc_wishlist_bound = true;

    function open() { menu.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
    function close() { menu.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }

    toggle.addEventListener('click', (e) => { e.preventDefault(); if (menu.classList.contains('is-open')) close(); else open(); });

    document.addEventListener('click', (e) => {
      if (!menu.contains(e.target) && !toggle.contains(e.target)) {
        if (menu.classList.contains('is-open')) close();
      }
    });

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  }

  const toggles = findAll(toggleSel);
  const menus = findAll(menuSel);
  if (toggles.length && menus.length) { toggles.forEach(t => menus.forEach(m => attach(t, m))); return; }
  createObserverForSelector(toggleSel, () => initWishlist(), { timeout: 4000 });
}

export { initWishlist };
export default initWishlist;
